import {deserializeObject} from "@/util/nativeHelper";

export function getOne({data}){
  return data.result[0] && deserializeObject(data.result[0])
}

export function getRawResult({data}) {
  return data.result
}
export function getList({data}) {
  return data.result.map(deserializeObject)
}